<script lang="ts" generics="ITEM">
    import type {SearchParams, Sorting, ViewableSearch} from 'src/typings';
    import {findFirst, byId} from 'shared/utils/array-utils';
    import type {SearchManager} from '../search-manager/search-manager';
    import KpSearchSortingSelector from './KpSearchSortingSelector.svelte';
    import type {Observable} from 'rxjs';
    import {exists} from 'shared/utils/custom-utils';

    export let searchManager: SearchManager<ITEM>;
    export let showing = false;

    let lastSearch: Observable<ViewableSearch<SearchParams, ITEM>>;
    $: lastSearch = searchManager.getLastSearch$();
    $: showing = exists($lastSearch) && $lastSearch.features && $lastSearch.features.includes('sorting') && $lastSearch.availableSortings.length > 1;

    let selectedSorting: Sorting;
    $: if (exists($lastSearch) && exists(searchManager.getFrontendParams()?.sorting)) {
        selectedSorting = findFirst($lastSearch.availableSortings, byId(searchManager.getFrontendParams().sorting.id));
    }

    function onSortingChange(sorting: Sorting) {
        searchManager.newSearchWithPartialParams({sorting});
    }
</script>

{#if showing}
    <KpSearchSortingSelector {selectedSorting}
                             availableSortings={$lastSearch.availableSortings}
                             on:change-sorting={(event) => onSortingChange(event.detail)}/>
{/if}